import CancelablePromise from 'mn-utils/CancelablePromise';
import {TChangePasswordRequest} from './types';
import {TResponse} from '@/types';
import {apiRequest} from '../../ws';
import {ENDPOINT_PASSWORD_SAVE} from '../../../constants/api';

export function apiAuthPasswordSet(params: TChangePasswordRequest): Promise<TResponse> {
  const url = ENDPOINT_PASSWORD_SAVE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}
